import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import CaseStudy from '@src/components/DisposalPage/CaseStudy'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import pallet from '../../json/pallet-disposal-data.json'

const palletServiceData = {
  name: 'Pallet Disposal and Recycling Services',
  description:
    'Nationwide pallet disposal and recycling for warehouses, stores, and distribution centers. Dimension collects wooden, plastic, and metal pallets in any condition, routing them to reuse or recycling with a waste diversion report.',
  serviceType: 'Pallet Disposal',
  url: 'https://getdimension.com/pallet-disposal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Wooden Pallet Recycling' },
    { name: 'Plastic Pallet Disposal' },
    { name: 'Metal Pallet Recycling' },
    { name: 'Recurring Warehouse Pallet Collection' },
  ],
}

const palletFAQData = {
  questions: pallet.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function PalletDisposal() {
  return (
    <>
      <Head>
        <title>Pallet Disposal and Recycling Services | Dimension</title>
        <meta
          name="description"
          content="Nationwide pallet disposal and recycling for wooden, plastic, and metal pallets. Warehouse volume from under $1 per pallet, any condition, with a waste diversion report."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/pallet-disposal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={palletServiceData} />
        <SchemaMarkup type="FAQPage" data={palletFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={pallet.pitch.heading}
          material={pallet.pitch.material}
          pitchText={pallet.pitch.pitchText}
          ctaLink={pallet.pitch.ctaLink}
          ctaText={pallet.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...pallet.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...pallet.benefits} />
        <CaseStudy {...pallet.caseStudy} />
        <Approach {...pallet.approach} />
        <FAQ {...pallet.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Cardboard Recycling',
              href: '/cardboard-recycling',
              description:
                'Box, stack, pallet, and bale cardboard pickup — the other stream every warehouse produces.',
            },
            {
              label: 'Dumpster Rental',
              href: '/dumpster-rental',
              description:
                'Roll-off containers up to 40 yards; a 30 yard holds roughly 100 pallets.',
            },
            {
              label: 'General Waste Disposal',
              href: '/general-waste-disposal',
              description:
                'Recurring commercial waste and recycling collection alongside your pallet pickups.',
            },
            {
              label: 'Junk Removal Services',
              href: '/junk-removal',
              description:
                'Fixtures, furniture, and mixed commercial junk cleared by a full-service crew.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default PalletDisposal
